import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip } from "./kit";

/// 5 Kas: admin rollerine arac bazinda yetki (sahip her seyi gorur)
const ROL = { manager: "Manager", moderator: "Moderatör", finance: "Finans", agency_rep: "Ajans temsilcisi" };

const RolYetki = () => {
  const [d, setD] = useState(null);
  const [v, setV] = useState({});
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.rolYetki().then((r) => {
      if (r?.status) {
        setD(r);
        setV(r.v || {});
      } else setD({ hata: r?.message || "Yüklenemedi" });
    });
  }, []);
  if (!d) return <div className="badu-empty">Yükleniyor…</div>;
  if (d.hata) return <div className="badu-empty">{d.hata}</div>;
  const degis = (rol, k) => {
    const l = new Set(v[rol] || []);
    l.has(k) ? l.delete(k) : l.add(k);
    setV({ ...v, [rol]: [...l] });
  };
  const kaydet = async () => {
    const r = await api.rolYetkiKaydet(v);
    setMsg(r?.status ? "Kaydedildi (30 sn içinde geçerli)." : r?.message || "Kaydedilemedi");
  };
  return (
    <div className="mainDashboard">
      <PageHead title="Rol yetkileri" sub="Yeni araçları hangi admin rolü kullanabilir? Sahip her şeyi görür." right={<button className="btn btn-primary btn-sm" onClick={kaydet}>Kaydet</button>} />
      {msg && <div style={{ marginBottom: 10 }}><Chip kind="info">{msg}</Chip></div>}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Araç</th>
                  {d.roller.map((r) => (
                    <th key={r} style={{ textAlign: "center" }}>{ROL[r] || r}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {d.araclar.map((a) => (
                  <tr key={a.key}>
                    <td>{a.ad}</td>
                    {d.roller.map((r) => (
                      <td key={r} style={{ textAlign: "center" }}>
                        <input type="checkbox" checked={(v[r] || []).includes(a.key)} onChange={() => degis(r, a.key)} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ fontSize: 12, color: "#6B7280" }}>
            Bu tablo rollerin mevcut yetkilerine EK yetki verir. Para sayfaları (kâr/zarar, kasa, çekimler) yalnız sahipte kalır. Her işlem "Yönetici kayıtları" sayfasına yazılır.
          </div>
        </div>
      </div>
    </div>
  );
};

export default RolYetki;
